import request from "@/router/axios";

// 收益结清  处理中
export const profitSettlementProcessingList = (current, size, params, search) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/profit_settlement_processing_list`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

// 收益结清  已结清
export const profitSettlementProcessedList = (current, size, params, search) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/profit_settlement_processed_list`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

export const profitSettlementPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

// 查询客户信息 平台信息
export const customerInfoAndPlatformInfo = (deptId,loanInformationId) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/customerInfoAndPlatformInfo`,
    method: "post",
    data: {
      deptId,loanInformationId
    },
  });
};

// 查询支付信息
export const selectById = (incomeSettlementID,supplementaryInfoId,loanpostid) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/selectById`,
    method: "get",
    params: {
      incomeSettlementID,
      supplementaryInfoId,
      loanpostid
    },
  });
};

//平台结清金额
export const displayPlatformAmount = (loanInformationId,platformRepaymentId) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/displayPlatformAmount`,
    method: "get",
    params: {
      loanInformationId,
      platformRepaymentId
    },
  });
};

// 确认结清
export const profitSettlementSave = (data) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/save`,
    method: "post",
    data: data,
  });
};

// 修改已经结清后中的相关信息
export const update = (data) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/update`,
    method: "post",
    data: data,
  });
};

// 表格导出
export const exportSettlement = (data) => {
  return request({
    url: `/api/blade-profitSettlement/profitSettlement/export-profit_settlement_processed_list`,
    method: "post",
    responseType: 'blob',
    data: data,
  });
};
